import {SET_CURRENT_CATEGORY} from '../../constants/actionTypes';

export const setCurrentCategory = (id) => ({
  type: SET_CURRENT_CATEGORY,
  payload: id,
});
